<template>
  <hr class="mdc-list-divider">
</template>

<script>
export default {
  name: 'mdc-drawer-divider'
}
</script>
